import { DateDropdownValue } from '@/typings/dateSelector';

const DATE_RANGE_CONFIG = [
    { name: 'Today', daysAgo: 0 },
    { name: 'Yesterday', daysAgo: 1 },
    { name: 'Last 7 days', daysAgo: 7 },
    { name: 'Last 15 days', daysAgo: 15 },
    { name: 'Last 30 days', daysAgo: 30 }
];

export enum DateFormat {
    MMMddYYYY,
    MMMdd,
    MMMYYYY,
    MMMddYYYYTime
}

export const formatDate = (date: Date | string, format = DateFormat.MMMddYYYY) => {
    if (!date) return '';

    const value = date instanceof Date ? date : new Date(date);
    const options: Record<DateFormat, Intl.DateTimeFormatOptions> = {
        [DateFormat.MMMYYYY]: { month: 'short', year: 'numeric' },
        [DateFormat.MMMdd]: { month: 'short', day: 'numeric' },
        [DateFormat.MMMddYYYY]: { month: 'short', day: 'numeric', year: 'numeric' },
        [DateFormat.MMMddYYYYTime]: {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: 'numeric',
            minute: 'numeric',
            hour12: true
        }
    };

    return new Intl.DateTimeFormat('en-US', options[format]).format(value);
};

export const dateToLocalISO = (date: Date) => {
    const pad = (n: string | number) => String(n).padStart(2, '0');
    return (
        date.getFullYear() +
        '-' +
        pad(date.getMonth() + 1) +
        '-' +
        pad(date.getDate()) +
        'T' +
        pad(date.getHours()) +
        ':' +
        pad(date.getMinutes()) +
        ':' +
        pad(date.getSeconds()) +
        '.' +
        String(date.getMilliseconds()).padStart(3, '0')
    );
};

export const getDateRanges = (date = new Date()): DateDropdownValue[] => {
    const referenceDate = new Date(date);
    referenceDate.setHours(0, 0, 0, 0);

    const globalEndDate = new Date(date);
    globalEndDate.setHours(23, 59, 59, 999);

    return DATE_RANGE_CONFIG.map(({ name, daysAgo }) => {
        const startDate = new Date(referenceDate);
        startDate.setDate(referenceDate.getDate() - daysAgo);
        const endDate = new Date(globalEndDate);
        endDate.setDate(globalEndDate.getDate() - (daysAgo === 1 ? 1 : 0));

        return {
            name: name,
            value: {
                from: dateToLocalISO(startDate),
                to: dateToLocalISO(endDate)
            }
        };
    });
};
